import React, { Component } from "react"
import { Badge, ModalFooter,  Modal, ModalHeader, ModalBody } from "reactstrap"
import Table from "../../components/Table"
import Select from "../../components/Select"
import { Link } from "react-router-dom"
import auth from "../../utils/auth"
import cfg from "../../utils/config"
import helper from "../../utils/helper"
import axios from "axios"

class GerenciarModulos extends Component {
    state = {
        data: [],
        loading: true,
        optionsEmpresa: [],
        acessosSelecionados: [],
        detalhes: { empresa: null },
        modal_status: false,
        modal_status_acessos: false,
        dataTableAcesso: []
    }

    componentDidMount() {
        this.getEmpresas(true, false)
    }

    getData = (state) => {
        this.setState({ loading: true })
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        let userInfo = auth.getUserInfo()
        let url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/acesso/modulo/?limit=${state.lineCount}` + state.filter

        if (state.url) {
            url = state.url
        }

        axios.get(url, config_me).then((res) => {
            this.setState({
                loading: false,
                data: res.data.results,
                count: res.data.count,
                next: res.data.next,
                previous: res.data.previous,
            })
        })
    }

    getEmpresas = (createOptions, dataTableAcesso) => {
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        let userInfo = auth.getUserInfo()
        let url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + "/acesso-modulo-quantidade-empresa/"

        axios.get(url, config_me) 
        .then((res) => {
            const empresas = res.data

            if(createOptions) {
                this.createOptionsEmpresa(empresas)
            }
           
            if(dataTableAcesso) {
               this.setState({dataTableAcesso: empresas})
            }
            
        })
    }

    createOptionsEmpresa = (empresas) => {
        let optionsEmpresa = []

        empresas.forEach(empresa => {
            optionsEmpresa.push({label: empresa.empresa_nome, value: empresa.empresa_id})    
        })

        this.setState({optionsEmpresa})
    }

    changeAcessos = (checked, id) => {
        let acessos = [...this.state.acessosSelecionados]

        if(checked) {
            acessos.push(id)
        } else {
            acessos = acessos.filter((id_acesso) => id_acesso != id) 
        }

        this.setState({acessosSelecionados: acessos})
    }

    changeEmpresa = (field, value) => {
        const detalhes = Object.assign({}, this.state.detalhes)
        detalhes[field] = value
        this.setState({detalhes})

        this.toggleModal(true, "default")
    }
    
    clearState = () => {
        this.setState({
            acessosSelecionados: [],
            detalhes: { empresa: null }
        })
    }

    migrar = () => {
        let userInfo = auth.getUserInfo()
        let url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + "/acesso/modulo/migrar/" + `${this.state.detalhes.empresa.value}/`

        const data = {
            acessos: this.state.acessosSelecionados
        }
    
        axios({
            url: url,
            method: "POST",
            data: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        })
        .then((res) => {
            this.toggleModal(false, "default")
            this.clearState()
            this.state.table.fetch()
        
            helper.dispatchEvent("showAviso", {
                message: res.data
            })
        })
        .catch((error) => {
            this.toggleModal(false, "default")

            helper.dispatchEvent("showAviso", {
                message: error.response.data
            })
        })
    }

    toggleModal = (status, modal) => {

        if(modal == 'default') {
            this.setState({modal_status: status})
        } else if(modal == "acessos") {
            this.setState({modal_status_acessos: status, dataTableAcesso: []})

            if(status) {
                this.getEmpresas(false, true)
            }
        }
       
    }

    render() {
        const { optionsEmpresa, acessosSelecionados, modal_status, detalhes, modal_status_acessos, dataTableAcesso } = this.state

        const columns = [
        {
            Header: "Selecionar Acesso",
            Accessor: "",
            Cell: (original) => {
                if(acessosSelecionados.length == 0) {
                    return <input checked={false} onChange={(e) => this.changeAcessos(e.target.checked, original.id)} type="checkbox"/>
                } else {
                    return <input onChange={(e) => this.changeAcessos(e.target.checked, original.id)} type="checkbox"/>
                }
                
            }
        },{
            Header: "Empresa",
            Accessor: "empresa.nome_fantasia",  
        },{
            Header: 'Tipo de Acesso',
            Accessor: 'acesso_tipo.descricao',
        }, {
            Header: 'Cliente',
            Accessor: 'cliente.nome_fantasia',
            Cell: (original) => {
                if(original?.cliente?.nome_fantasia) {
                    return(
                        <Link to={`/cliente/${original?.cliente?.id}/editar/?modulo=true`}>
                            {original?.cliente?.nome_fantasia}
                        </Link>
                    )
                } else {
                    return <span>---</span>
                } 
            }
        }, {
            Header: 'Ativo',
            Accessor: 'ativo',
            sortable: false,
            Cell: (original) => {
                return original.ativo ?
                    <Badge color="success">Sim</Badge>
                    :
                    <Badge color="secondary">Não</Badge>
            }
        }, {
            Header: 'Data do Cancelamento',
            Accessor: 'data_cancelamento',
            sortable: false,
            Cell: (original) => {
                if (original.data_cancelamento) {
                    let date = new Date(Date.parse(original.data_cancelamento))
                    const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }

                    return <span>{new Intl.DateTimeFormat('pt-Br', options).format(date)}</span>
                } else {
                    return <span>---</span>
                }
            }
        }]

        return(
            <>
                <Modal toggle={() => this.toggleModal(false, "default")} isOpen={modal_status}>
                    <ModalHeader toggle={() => this.toggleModal(false, "default")}>Confirmar Migração</ModalHeader>
                    <ModalBody>
                        Tem certeza que deseja realizar a migração dos acessos selecionados para a empresa <span style={{fontWeight: "bold", fontSize: "15px"}}>{detalhes.empresa?.label}</span> ?
                    </ModalBody>
                    <ModalFooter>
                        <button onClick={this.migrar} className="hdv-btn-forms hdv-btn-green">Confirmar</button>
                        <button onClick={() => this.toggleModal(false, "default")} className="hdv-btn-forms hdv-btn-yellow">Cancelar</button>
                    </ModalFooter>
                </Modal>
        
                <Modal toggle={() => this.toggleModal(false, "acessos")}  isOpen={modal_status_acessos}>
                    <ModalHeader toggle={() => this.toggleModal(false, "acessos")} >Acessos</ModalHeader>
                    <ModalBody>
                        <table className="afira-table">
                            <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th>Status</th>
                                    <th>Utilizados</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dataTableAcesso.map((acesso, key) => {
                                        return (
                                            <tr key={key}>
                                                <td title={acesso.empresa_nome}>{acesso.empresa_nome}</td>
                                                <td title={acesso.disponiveis}>
                                                    <progress style={{ width: "80px" }} className={acesso.quantidade_acessos_modulos === acesso.utilizados ? "progressMax" : ""} value={acesso.utilizados} max={acesso.quantidade_acessos_modulos}>
                                                    </progress>
                                                </td>
                                                <td title={acesso.utilizados}>{acesso.utilizados}</td>
                                                <td title={acesso.quantidade_acessos_modulos}>{acesso.quantidade_acessos_modulos}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </ModalBody>    
                </Modal>

                <div style={{alignItems: "center"}} className='row'>
                    <div className='col-md-3'>
                        <Select
                            value={detalhes.empresa}
                            onChange={(e) => this.changeEmpresa('empresa', e)} 
                            options={optionsEmpresa}
                            disabled={acessosSelecionados.length == 0}
                        />
                    </div>
                    <div>
                        <button onClick={() => this.toggleModal(true, "acessos")} className="hdv-btn-forms hdv-btn-blue">Ver Acessos</button>
                    </div> 
                </div>

                <Table
                    notEditFirstColum={true}
                    data={this.state.data}
                    loading={this.state.loading}
                    next={this.state.next}
                    count={this.state.count}
                    previous={this.state.previous}
                    columns={columns}
                    onFetchData={this.getData}
                    onUpdate={(table) => this.setState({ table })}
                />
            </>
        )
    }
}

export default GerenciarModulos